import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import PadSizeDescriptions from '@components/storefront/PadSizeDescriptions';
import PadSizeGrid from '@components/storefront/PadSizeGrid';
import { MEDIA } from '@constants';

type Props = {};

const VideoHalfRowPadsInfo: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <TopTexts>
        <Typography $variant={TextVariant.Heading3} $mobileVariant={TextVariant.Heading5}>
          {t('components.pads-absorbs-all')}
        </Typography>
        <Typography $variant={TextVariant.BodyRegularLG}>{t('components.pads-absorbs-all-desc')}</Typography>
      </TopTexts>
      <PadSizeGrid />
      <PadSizeDescriptions />
    </Wrapper>
  );
};

export default VideoHalfRowPadsInfo;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 48px 120px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${MEDIA.laptopL} {
    padding: 48px 70px;
  }

  ${MEDIA.laptopM} {
    padding: 56px 30px;
  }

  ${MEDIA.laptop} {
    padding: 56px 16px;
  }
`;

const TopTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
